module.exports = __webpack_public_path__ + "img/country-gravy.4f169bae.jpg";